import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

const toast = (props) => {

	if(props.toast.text === null) return null;

	let toast_classes = 'toast screen-only toast--' + props.toast.kind;

	return (
		<div className={toast_classes}>
			<div className='wrapper wrapper--narrow clearfix'>
				<div className='toast__control'><span onClick={() => props.rdxClearToast()}><i className='fas fa-times'></i></span></div>
				<div className='toast__content'>
					<p className='toast__line'><i className='fas fa-paperclip'></i>&nbsp; {props.toast.text}</p>
				</div>
			</div>
		</div>
	);

}


const mapStateToProps = state => {
	return {
		toast: state.toast
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxClearToast: () => 	dispatch(actions.clearToast())
	};
}


export default connect(mapStateToProps,mapDispatchToProps)(toast);


// WEBPACK FOOTER //
// ./src/Blocks/Toast.js